var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 19.6875,
    fill: "#007FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 30C21.0938 30.373 21.2419 30.7306 21.5056 30.9944C21.7694 31.2581 22.127 31.4062 22.5 31.4062C22.873 31.4062 23.2306 31.2581 23.4944 30.9944C23.7581 30.7306 23.9062 30.373 23.9062 30V23.9062H30C30.373 23.9062 30.7306 23.7581 30.9944 23.4944C31.2581 23.2306 31.4062 22.873 31.4062 22.5C31.4062 22.127 31.2581 21.7694 30.9944 21.5056C30.7306 21.2419 30.373 21.0938 30 21.0938H23.9062V15C23.9062 14.627 23.7581 14.2694 23.4944 14.0056C23.2306 13.7419 22.873 13.5938 22.5 13.5938C22.127 13.5938 21.7694 13.7419 21.5056 14.0056C21.2419 14.2694 21.0938 14.627 21.0938 15V21.0938H15C14.627 21.0938 14.2694 21.2419 14.0056 21.5056C13.7419 21.7694 13.5938 22.127 13.5938 22.5C13.5938 22.873 13.7419 23.2306 14.0056 23.4944C14.2694 23.7581 14.627 23.9062 15 23.9062H21.0938V30Z",
    fill: "#F6FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyToken);
export default __webpack_public_path__ + "static/media/BuyToken.0940291886650341484fbc3dd2bcb711.svg";
export { ForwardRef as ReactComponent };